/**
 * List of training samples.
 */
import { Sample } from '@/services/api'
import { SampleCard } from './SampleCard'

interface SampleListProps {
  samples: Sample[]
  onEdit: (sample: Sample) => void
  onDelete: (sampleId: string) => void
}

export const SampleList: React.FC<SampleListProps> = ({
  samples,
  onEdit,
  onDelete,
}) => {
  if (samples.length === 0) {
    return (
      <div className="text-center py-16">
        <svg
          className="mx-auto h-16 w-16 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
        <h3 className="mt-4 text-lg font-medium text-gray-900">No training samples yet</h3>
        <p className="mt-2 text-gray-600 max-w-md mx-auto">
          Upload your first sample to improve AI report generation. Training samples help the AI
          learn your preferred report structure and style.
        </p>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {samples.map((sample) => (
        <SampleCard
          key={sample.sample_id}
          sample={sample}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  )
}
